import React from 'react';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import './CustomSelect.scss';


export const CuitInput = (props) => {
    return <InputMask {...props} mask="99-99999999-9" maskChar=" " />;
};

export const CustomSelect = ({name, onChange, options, value, isSearchable, disabled, isClearable = true, placeholder, label}) => {
    const defaultValue = (options, value) => {
        return value ? options?.find((option) => option.value === value) : null;
    };

    return (
        <div className={'v2-select-box-container'}>
            <p className={'body-3 c-text-subtitle'}>{label}</p>
            <Select
                classNamePrefix={'custom-select'}
                name={name}
                value={defaultValue(options, value)}
                onChange={(option) => {
                    onChange(option ? option.value : null);
                }}
                options={options}
                isSearchable={isSearchable}
                isDisabled={disabled}
                isClearable={isClearable}
                className={'c-text-base'}
                noOptionsMessage={() => 'No se encontraron opciones'}
                placeholder={placeholder || 'Elija una opción'}/>
        </div>
    );
};

export default CustomSelect;
